import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import axios from 'axios';
import '../components-css/Ministries.css';

const Ministries = () => {
  const [ministries, setMinistries] = useState([]);
  const [loading, setLoading] = useState(true);
  const imgRefs = useRef([]);
  const rafId = useRef(null);
  const currentOffsets = useRef([]);

  useEffect(() => {
    axios.get('/api/ministries.json')
      .then(res => setMinistries(res.data))
      .catch(() => setMinistries([]))
      .finally(() => setLoading(false));
  }, []);

  const updatePositions = useCallback(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const viewportCenter = window.innerHeight / 2;
    const maxOffset = 40;
    const lerp = 0.12; // Factor de interpolación para suavidad

    imgRefs.current.forEach((el, idx) => {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const elCenter = rect.top + rect.height / 2;
      const distanceRatio = (elCenter - viewportCenter) / (window.innerHeight / 2);
      const clamped = Math.max(-1, Math.min(1, distanceRatio));
      const direction = idx % 2 === 0 ? -1 : 1;
      const targetX = clamped * maxOffset * direction;

      // Inicializar offset actual si no existe
      if (currentOffsets.current[idx] === undefined) {
        currentOffsets.current[idx] = targetX;
      }

      // Interpolar suavemente hacia el objetivo
      currentOffsets.current[idx] += (targetX - currentOffsets.current[idx]) * lerp;
      el.style.transform = `translateX(${currentOffsets.current[idx]}px)`;
    });

    rafId.current = requestAnimationFrame(updatePositions);
  }, []);

  useEffect(() => {
    rafId.current = requestAnimationFrame(updatePositions);
    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, [updatePositions, ministries]);

  if (loading) return <div className="text-center my-5"><Spinner animation="border" /></div>;

  return (
    <section id="actividades">
      <Container>
        <div className="section-title text-center mb-5">
          <h2 className="section-title__title">Actividades</h2>
        </div>
        <p className="activities-intro text-center mb-5">
          ¡Estas son algunas de nuestras actividades! Te invitamos a sumarte. <br></br>Si querés conocer más, en la seccion {' '}
          <a href="#visitanos">Visitanos</a> podés encontrar como contactarnos.
        </p>
        {ministries.map((min, idx) => (
          <Row key={min.id} className="ministry-row" id={min.id}>
            {idx % 2 === 0 ? (
              <>
                {/* Imagen izquierda */}
                <Col xl={6} className="ministry-col">
                  <div
                    ref={el => (imgRefs.current[idx] = el)}
                    className="ministry-img-bg ministry-img-parallax"
                    style={{ backgroundImage: `url(${min.img})` }}
                  >
                  </div>
                </Col>
                {/* Texto derecha */}
                <Col xl={6} className="ministry-text-col">
                  <Card className="ministry-card-text">
                    <Card.Body>
                      <Card.Title>{min.title}</Card.Title>
                      <Card.Subtitle className="card-subtitle">{min.age}</Card.Subtitle>
                      <Card.Text>{min.desc}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </>
            ) : (
              <>
                {/* Texto izquierda */}
                <Col xl={6} className="ministry-text-col">
                  <Card className="ministry-card-text">
                    <Card.Body>
                      <Card.Title>{min.title}</Card.Title>
                      <Card.Subtitle className="card-subtitle">{min.age}</Card.Subtitle>
                      <Card.Text>{min.desc}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                {/* Imagen derecha */}
                <Col xl={6} className="ministry-col">
                  <div
                    ref={el => (imgRefs.current[idx] = el)}
                    className="ministry-img-bg ministry-img-parallax"
                    style={{ backgroundImage: `url(${min.img})` }}
                  >
                  </div>
                </Col>
              </>
            )}
          </Row>
        ))}
      </Container>
    </section>
  );
};

export default Ministries;
